<script lang="ts" setup>
  import type { GetByPartnerIdOut } from '~/types/ecommerce/generated.codegen';

  const cart = inject<Ref<GetByPartnerIdOut>>('cart')!;
  const { track } = useTracker();
  const route = useRoute();

  function redirectToCart() {
    const { dc_id, segmentation_id } = route.query;
    const query: Record<string, string> = {};
    if (dc_id) query.dc_id = dc_id as string;
    if (segmentation_id) query.segmentation_id = segmentation_id as string;

    navigateTo({
      name: 'cart',
      query,
    });
    track('header_menu_icon_button_carrinho');
  }

  const cartItemsAmount = computed(() => {
    if (cart.value?.category?.description === 'product') {
      return cart?.value?.products?.flatMap(product =>
        product?.items?.map(item => item),
      ).length;
    }
    return cart.value?.items?.length;
  });
</script>

<template>
  <NuxtLink to="/cart" @click="redirectToCart()">
    <div class="store-shopping-cart">
      <span v-if="cartItemsAmount" class="store-shopping-cart__count">{{
        cartItemsAmount
      }}</span>
      <icon-girassol:shopping-cart class="icon" />
    </div>
  </NuxtLink>
</template>

<style lang="scss">
  .store-shopping-cart {
    @apply relative flex items-center justify-center;
    @apply w-md h-md;

    .icon {
      @apply icon-size-medium;
    }

    &__count {
      @apply absolute top-[5px] right-[5px];
      @apply flex items-center justify-center;
      @apply h-4xs w-4xs;
      @apply bg-feedback-negative-pure;
      @apply text-neutral-high-pure;
      @apply fonts-body-small-regular;
      @apply rounded-full;
    }
  }
</style>
